export default {
  "ConfirmDialog.accept": "Sí",
  "ConfirmDialog.cancel": "No",
};
